export class PlayerNotes {
  constructor(json?: any) {
    this.appUserId = json && json.app_user_id || null;
    this.scheduledGameId = json && json.schedule_games_id || null;
    this.playerRnid = json && json.player_rnid || null;
    this.notes = json && json.notes || null;

    this.gmScore = json && json.gmscore || null;
    this.score = json && json.score || null;
    this.optWant = json && json.optwant || null;
    this.gmFlag = json && json.gmflag || null;
    this.playerType = json && json.platype || null;
    this.potential = json && json.potential || null;
    this.projection = json && json.projection || null;
    this.fight = json && json.fight || null;
    this.character = json && json.character || null;
    this.quality = json && json.quality || null;
    this.potQual = json && json.potqual || null;
  }

  appUserId: number;
  scheduledGameId: number;
  playerRnid: number;
  notes: string;

  gmScore: number;
  score: number;
  optWant: number;
  gmFlag: number;
  playerType: number;
  potential: number;
  projection: number;
  fight: number;
  character: number;
  quality: number;
  potQual: number;

  toJSON() {
    return {
        app_user_id: this.appUserId,
        schedule_games_id: this.scheduledGameId,
        player_rnid: this.playerRnid,
        notes: this.notes,
        gmscore: this.gmScore,
        score: this.score,
        optwant: this.optWant,
        gmflag: this.gmFlag,
        platype: this.playerType,
        potential: this.potential,
        projection: this.projection,
        fight: this.fight,
        character: this.character,
        quality: this.quality,
        potqual: this.potQual
    }
  }

  hasNotes() : boolean {
    return !!(this.notes || 
        this.gmScore ||
        this.score ||
        this.optWant ||
        this.gmFlag ||
        this.playerType ||
        this.potential ||
        this.projection ||
        this.fight ||
        this.character ||
        this.quality ||
        this.potQual
        );
  }
}
